export default function sortNames (list){
    return list.sort((a,b) => {
        let x = a?.lname?.toLowerCase() + a?.fname?.toLowerCase();
        let y = b?.lname?.toLowerCase() + b?.fname?.toLowerCase();
        return (x < y) ? -1 : (x > y) ? 1 : 0
    })
}